module.exports = new __parcel__URL__("shop_machines_brawler_cage.04b39913.png").toString();